import React, { ReactElement } from 'react';
import featureFlags, { FrontendFeature } from '../../../featureFlags';
import { OrganizationUser } from '@enview/interface/types/OrganizationUser';

export enum AISummaryType {
  IntroducedVersionSummary = 'introduced-version',
  VersionToVersionSummary = 'version-to-version',
}

export const formatPlainTextToReact = (summaryText: string): ReactElement[] => {
  const lineSeparatedStrings = summaryText.split('\n');
  const elements: ReactElement[] = [];
  lineSeparatedStrings.forEach((text) => {
    if (text.length > 0) {
      elements.push(<p>{text}</p>);
    }
  });
  return elements;
};

export const isJurisdictionSupportedForAISummary = (
  jurisdictionAbbreviation: string,
  summaryType: AISummaryType,
  orgUser?: OrganizationUser,
): boolean => {
  const j = jurisdictionAbbreviation.toLowerCase();
  const unsupported = ['hi', 'ma', 'tn', 'dc', 'ng'];
  if (
    !(
      orgUser &&
      featureFlags.isFeatureEnabledForUser(
        FrontendFeature.BillTrackingFederalSummaries,
        orgUser,
      )
    )
  ) {
    unsupported.push('us', 'usa');
  }
  const introducedVersionOnly = ['ca', 'nj'];
  if (unsupported.includes(j)) {
    return false;
  } else if (
    summaryType === AISummaryType.VersionToVersionSummary &&
    introducedVersionOnly.includes(j)
  ) {
    return false;
  }
  return true;
};

export const checkForInsightsPolicyTopicEligibility = (jurisdictions: any): boolean => {
  // TODO: eventually refer to jurisdiction_data_types table for this array
  const jurisdictionsWithInsightsPolicyTopics = [
    'al',
    'ar',
    'az',
    'co',
    'ct',
    'fl',
    'ga',
    'ia',
    'id',
    'ks',
    'la',
    'me',
    'mn',
    'nh',
    'ny',
    'oh',
    'ri',
    'tn',
    'ut',
    'va',
    'vt',
    'wi',
    'wv',
    'wy',
  ];
  // all selected jurisdictions must have AI bill topics
  if (jurisdictions.length > 0) {
    return jurisdictions.every((j: any) =>
      jurisdictionsWithInsightsPolicyTopics.includes(j),
    );
  }
  return false;
};
